        export const advertsloaded  = false;

        //enums

        export const oddstype = Object.freeze({
            decimal: 1,
            fractional: 2,
            american: 3
        })

        export const bannersize = Object.freeze({
            BackBanColour: 0,
            Ban468x60: 1,
            Ban120x600: 2,
            Ban728x90: 3,
            BanURL: 4,
            Ban320x50: 5,
            Ban300x250: 6

        })
        export const screensize = Object.freeze({
            small: 0,
            medium: 1,
            large: 2,
            popup: 3

        })

        export const tabtype = Object.freeze({
            notitle: 0,
            imageonly: 1,
            textonly: 2,
            imageandtext: 3,
            textbelowimage: 4,
            colourstripwwithtest: 5

        })
        
        export const calendartype = Object.freeze({
            daytoggle: 0,
            fromdate: 1,
            fromandtoodate: 2,
            daytoggleandfromdate: 3

        })

                // global datetime method
        export const dateformattype = {

            full: { dateStyle: 'full' },
            day: { weekday: 'short' },
            daylong: { weekday: 'long' },
            notime: { weekday: 'short'},
            daytime: { weekday: 'long', hour: '2-digit', minute: '2-digit', hour12: false },
            timeonly: { hour: '2-digit', minute: '2-digit', hour12: false },
            daymonth: { day: 'numeric', month: 'short' },
            daymonthtime: { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false },
            fulldaymonthtime: { weekday: 'long', day: '2-digit', month: 'long', hour: '2-digit', minute: '2-digit', hour12: false },
            dayshortmonthtime: {day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false},
            monthyear: {month: 'long', year: 'numeric'},
            yearonly: {year: 'numeric'},
            monthonly: {month: 'long'},
            daymonthshort: { day: 'numeric', month: 'numeric' },
            monthyearnotime: {month: 'long', year: 'numeric'},
        }
